/* eslint eqeqeq: "off", curly: "error", @typescript-eslint/no-unused-vars: "off", react-hooks/exhaustive-deps: "off", array-callback-return: "off", no-eval: "off", jsx-a11y/alt-text: "off", jsx-a11y/anchor-is-valid: "off" */
import React, { useEffect, useState } from "react";
import * as API from "../../http/api";
import { closelightbox } from "../../util/Functions";
import { Grid, TextField, Button, DialogContent, Dialog, DialogTitle, IconButton, MenuItem, Card, FormControlLabel, Checkbox, Link } from "@mui/material";
import { ModalStyle } from "../../util/Styles";
import { Close, KeyboardReturn } from "@mui/icons-material";
import DataTable from "react-data-table-component";
import { customStyles2 } from "../../util/TableStyles";

const AdminFormsPLD = (props) => {
    const [zPos, setZPos] = useState(45);
    const [step, setStep] = useState(0);
    const [listPLd, setListPLd] = useState([]);
    const [showTable, setShowTable] = useState({view: false, key: null});
    const [itemPld, setItemPld] = useState({
        name: "",
        fields: [],
        cdate: "",
        label: "",
        udate: "",
        uuid: "",
    });

    useEffect(() => {
        setListPLd(props.contentModal.data);
    }, []);

    const columns = [
        { selector: (row) => row.key, name: "Key", width:"20%", wrap: true, sortable: true },
        { selector: (row) => row.label, name: "Label", width:"80%", wrap: true, sortable: true },
    ]

    const pld = async (e) => {
        props.changeLoader(true);
        setZPos(-1)

        let data = {
            type: "getById",
            uuid: e.target.value,
        };
        let request = await API.service("devPld", data, props.pos, props.changeAlert, props.changeLoader, props.history);
        if (request.status === 200 || request.data.data.response !== "BAD") {
            let content = request.data.data.content
            if (step === 0) {
                setStep(1);
                props.changeLoader(false);
                setZPos(45)
                return setItemPld(JSON.parse(JSON.stringify(content)));
            }
        } else {
            props.changeAlert(true, "error", request.data.data.message);
            props.changeLoader(false);
            setZPos(45)
        }
    };
    const back = () => {
        setItemPld({
            name: "",
            fields: [],
            cdate: "",
            label: "",
            udate: "",
            uuid: "",
        });
        if (step === 1) {
            setStep(0);
        }
    };
    const required = async (item) => {
        props.changeLoader(true);
        setZPos(-1)

        itemPld.fields.forEach((ele) => {
            if (ele.findValue === item.findValue) {
                if (ele.required) {
                    ele.required = false;
                } else {
                    ele.required = true;
                }
            }
        });
        let data = {
            type: "update",
            data: itemPld,
        };
        let request = await API.service("devPld", data, props.pos, props.changeAlert, props.changeLoader, props.history);
        if (request.status == 200 || request.data.data.response !== "BAD") {
            setItemPld(itemPld);
            props.changeAlert(true, "success", "Operación realizada");
            props.changeLoader(false);
            setZPos(45)
        } else {
            props.changeAlert(true, "error", request.data.data.message);
            props.changeLoader(false);
            setZPos(45)
        }
    };
    const show = async (item) => {
        props.changeLoader(true);
        setZPos(-1)
        itemPld.fields.forEach((ele) => {
            if (ele.findValue === item.findValue) {
                if (ele.show) {
                    ele.show = false;
                } else {
                    ele.show = true;
                }
            }
        });
        let data = {
            type: "update",
            data: itemPld,
        };
        let request = await API.service("devPld", data, props.pos, props.changeAlert, props.changeLoader, props.history);
        if (request.status === 200 || request.data.data.response !== "BAD") {
            setItemPld(itemPld);
            props.changeAlert(true, "success", "Operación realizada");
            props.changeLoader(false);
            setZPos(45)
        } else {
            props.changeAlert(true, "error", request.data.data.message);
            props.changeLoader(false);
            setZPos(45)
        }
    };

    const valueChange = (item, e) => {
        item.value = e.target.value;
        itemPld.fields.forEach((ele) => {
            if (ele.findValue === item.findValue) {
                ele.value = e.target.value;
            }
        });
        setItemPld(itemPld);
    };

    const update = async (item, e) => {
        props.changeLoader(true);
        setZPos(-1)
        itemPld.fields.forEach((ele) => {
            if (ele.findValue === item.findValue) {
                ele.value = item.value;
            }
        });
        let data = {
            type: "update",
            data: itemPld,
        };
        let request = await API.service("devPld", data, props.pos, props.changeAlert, props.changeLoader, props.history);
        if (request.status === 200 || request.data.data.response !== "BAD") {
            setItemPld(itemPld);
            props.changeAlert(true, "success", "Operación realizada");
            props.changeLoader(false);
            setZPos(45)
        } else {
            props.changeAlert(true, "error", request.data.data.message);
            props.changeLoader(false);
            setZPos(45)
        }
    };

    const handleTable = (key) => {
        if(showTable.view){
            setShowTable({view: false, key: null })
        } else {
            setShowTable({view: true, key: key })
        }
    }

    return (
        <Dialog open={true} sx={{ zIndex: zPos, filter: zPos !== 45 ? "blur(2px)" : "none" }} maxWidth={step === 0 ? 'md' : 'lg'} fullWidth>
            <ModalStyle property={String(false)}>
                <DialogTitle style={{ marginBottom: "0" }}>
                    <span>
                        Control de formularios PLD
                        <p id="subtitle_2">{props.contentModal["title"]}</p>
                    </span>
                    {step === 1 && <IconButton id="secondButton" onClick={back} sx={{padding: 2, right: '70px !important'}}><KeyboardReturn sx={{padding: "7px", borderRadius: 2, boxSizing: "content-box", color: "white", backgroundColor: "#8bc179" }}/></IconButton>}
                    <IconButton id="headButton" onClick={closelightbox} sx={{padding: 2}}><Close sx={{padding: "7px", borderRadius: 2, boxSizing: "content-box", color: "white", backgroundColor: "#3743aa" }}/></IconButton>
                </DialogTitle>

                <DialogContent>
                    <Grid container spacing={2}>
                    {step === 0 &&
                        <Grid item xs={12} mt={1} mb={2}>
                            <TextField label="Formularios" onChange={pld.bind(this)} defaultValue={-1} select size="small" fullWidth>
                                <MenuItem value={-1} disabled>Seleccione</MenuItem>
                                {listPLd?.map((item, index) => (
                                    <MenuItem key={item.uuid} value={item.uuid}>
                                        {item.label}
                                    </MenuItem>
                                ))}
                            </TextField>
                        </Grid>
                    }

                    {step === 1 && itemPld.fields.length > 0 &&
                        <>
                            <Grid item xs={12}>Nombre: {itemPld.name} </Grid>
                            <Grid item xs={12} sx={{paddingTop: '0 !important'}}>Label: <strong>{itemPld.label}</strong></Grid>
                            <Grid item xs={12} sx={{paddingTop: '0 !important'}}>Fecha de creación: {itemPld.udate}</Grid>
                            <Grid container item spacing={2} sx={{backgroundColor: '#fafafa', padding: '8px 16px', paddingRight: 4}} m={2} pl={0} mr={0}>
                                {itemPld.fields?.map((item, key) => {
                                    return (
                                        <Grid item xs={6} key={key}>
                                            <Card style={{padding: 20}}>
                                                <Grid item xs={12}><strong>Label: </strong>{item.label}</Grid>
                                                <Grid item xs={12}><strong>FindValue: </strong>{item.findValue}</Grid>
                                                <Grid item xs={6}><strong>Type: </strong>{item.type}</Grid>
                                                {(item.type === 'text' || item.type === 'number') &&
                                                    <Grid container item spacing={2} pt={2}>
                                                        <Grid item xs={8}>
                                                            <TextField label="Value" onChange={valueChange.bind(this,item)} size="small" fullWidth />
                                                        </Grid>
                                                        <Grid item xs={4}>
                                                            <Button id="buttonCancel" variant="outlined" onClick={update.bind(this,item)}>Actualizar</Button>
                                                        </Grid>
                                                    </Grid>
                                                }
                                                {item.type === "select" &&

                                                    <Grid container item spacing={2} pt={2}>
                                                        <Grid item xs={8}>
                                                            <TextField label="Value" onChange={valueChange.bind(this)} value={item.value} size="small" fullWidth />
                                                        </Grid>
                                                        <Grid item xs={4}>
                                                            <Button id="buttonCancel" variant="outlined" onClick={update.bind(this,item)}>Actualizar</Button>
                                                        </Grid>
                                                        <Grid item xs={8}>
                                                            <Link onClick={() => handleTable(key)} sx={{cursor: 'pointer'}}><strong>{!showTable.view ? 'Ver Tabla' : 'Ocultar Tabla'}</strong></Link> 
                                                        </Grid>
                                                        {showTable.view && showTable.key === key &&
                                                            <div style={{ width: "100%", padding:16 }}>
                                                                <DataTable
                                                                    data={item.values}
                                                                    columns={columns}
                                                                    customStyles={customStyles2}  
                                                                    dense
                                                                />
                                                            </div>
                                                        }
                                                    </Grid>
                                                }
                                                <Grid item xs={6}>
                                                    <FormControlLabel control={<Checkbox checked={item["required"]} onChange={required.bind(this, item)}/>} label={'Requerido'} id="yes"/>
                                                    <FormControlLabel control={<Checkbox checked={item["show"]} onChange={show.bind(this, item)}/>} label={'Show'} id="yes"/>
                                                </Grid>
                                            </Card>
                                        </Grid>
                                    )
                                })}
                            </Grid>
                        </>
                    }
                    </Grid>
                </DialogContent>
            </ModalStyle>
        </Dialog>
    );
};

export default AdminFormsPLD;
